export var TypeNumberRounding;
(function (TypeNumberRounding) {
    TypeNumberRounding[TypeNumberRounding["None"] = 0] = "None";
    TypeNumberRounding[TypeNumberRounding["Floor"] = 1] = "Floor";
    TypeNumberRounding[TypeNumberRounding["Round"] = 2] = "Round";
    TypeNumberRounding[TypeNumberRounding["Ceil"] = 3] = "Ceil";
})(TypeNumberRounding || (TypeNumberRounding = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/round-format/TypeNumberRounding.ts
// module id = 206
// module chunks = 3